import BaseRadio from './BaseRadio';
import RadioGroup from './Group';
const Radio = BaseRadio;
Radio.Group = RadioGroup;
export default Radio;
//# sourceMappingURL=index.js.map